import StockAddressingInBatchPage from './StockAddressingInBatchPage'

export default StockAddressingInBatchPage
